import 'animate.css'

const Results= ({ results, nextTab, nextExercise }) => {

setTimeout(() => {
    nextTab(nextExercise)
}, 3000);

console.log(results, "results")

const result = results.map((score,id) => (
    <div className={`h-5 w-6 rounded-full shdow-sm opacity-90 ${score ? 'bg-green-400' : 'bg-red-400'} `}
        key={id}
    >
    </div>)
)



return (
    <div className="exercise-stage">
        <p className="panel-heading">Round complete</p>
        <div className="m-auto flex flex-row gap-2 p-10">
        {result}
        </div>

        <div className="mx-auto flex flex-col p-5 text-center font-medium">
            <h1 className="mb-4 text-lg text-slate-500">Moving on to</h1>
            <h2 className="mb-20 font-serif text-4xl font-bold text-cyan-950 animate__animated animate__zoomIn">{nextExercise}</h2>
        </div>
    </div>
    );
};

export default Results;
